import React from "react";
import { LongTextLabel, Toast } from "@sscs/ui";
import { Dialog } from "Components";
import { Member } from "Types";
import { apiErrorToast } from "Utils";
import { useRemoveUsersFromGroupMutation } from "../../services/organizations.api";

type RemoveGroupMemberProps = {
  member: Member;
  groupId: string;
  isOpen: boolean;
  onClose: () => void;
};

const RemoveGroupMember = ({
  member,
  groupId,
  isOpen,
  onClose,
}: RemoveGroupMemberProps): React.JSX.Element => {
  const [removeUser] = useRemoveUsersFromGroupMutation();

  const handleConfirm = async () => {
    try {
      await removeUser({
        groupId: groupId,
        body: {
          users: [member.user_id],
        },
      }).unwrap();

      Toast.show({
        title: "Removed member from the group",
        type: "success",
      });
    } catch (error) {
      apiErrorToast(error, "Could not remove member from the group");
    }

    onClose();
  };

  return (
    <Dialog
      title="Remove group member?"
      confirmText="Remove"
      isOpen={isOpen}
      onCancel={onClose}
      onClose={onClose}
      onConfirm={handleConfirm}
      cancelButtonColor="primary"
      confirmButtonColor="secondary"
    >
      <div>
        Are you sure you want to remove{" "}
        <b>
          <LongTextLabel label={member.email} maxCharacters={100} inline />
        </b>{" "}
        from the group?
      </div>
    </Dialog>
  );
};

export default RemoveGroupMember;
